import { InputType, InputValidationType } from "@/components/input";
import styles from "./contact_form.module.css";
import React from 'react';
import { BasicInput } from "@/components/input/components/basicInput";
import { TextAreaInput } from "@/components/input/components/textareaInput";
import { CheckboxInput } from "@/components/input/components/checkboxInput";

export const getContactForm = (initialData : any) => {
    return [
        {
          className: styles.contact_content,
          columns : [
            {
              title: 'Nombre',
              name: 'name',
              type: InputType.TEXT,
              inputComponent: BasicInput,
              required: true,
              validations : [
                {
                  type : InputValidationType.NOT_EMPTY,
                  title : 'Debe especificar un nombre'
                }
              ]
            },
            {
              title: 'Teléfono',
              name: 'phone',
              type: InputType.TEXT,
              inputComponent: BasicInput,
            }
          ]
        },
        {
          className: styles.contact_content,
          columns : [
            {
              title: 'Email',
              name: 'mail',
              type: InputType.EMAIL,
              inputComponent: BasicInput,
              required: true,
              validations : [
                {
                  type : InputValidationType.NOT_EMPTY,
                  title : 'Debe especificar un email'
                }
              ]
            },
            /* {
              title: 'Empresa',
              name: 'company',
              type: InputType.TEXT
            } */
          ]
        },
        {
          columns : [
            {
              title: '¿En qué podemos ayudarte?',
              name: 'content',
              type: InputType.TEXTAREA,
              inputComponent: TextAreaInput,
              value: initialData.content,
              className: styles.contact_content_form_textarea
            }
          ]
        },
        {
          columns : [
            {
              name: 'terms',
              type: InputType.CHECKBOX,
              label: <>He leído y acepto los términos de la <a className={styles.contact_content_other_block__value} href="/legal/service_conditions" title="Clausula proteccion de datos">cláusula adicional de
              protección de datos</a></>,
              inputComponent: CheckboxInput,
              validations : [
                {
                  type : InputValidationType.TRUE,
                  title : 'Debes aceptar los terminos y condiciones'
                }
              ]
            }
          ]
        },
      ]
}